import { Injectable } from '@angular/core';
import { SvgEditExtension, SvgEditExtensionObject } from '@models/svg-edit-extension';
import { CanvasService } from './canvas.service';
import { CanvasInputMode, CanvasInputModeService } from './canvas-input-mode.service';
import { SelectedElementsService } from './selected-elements.service';

@Injectable({ providedIn: 'root' })
export class StatusIndicatorExtensionService implements SvgEditExtension {
    name: string = 'statusIndicatorExtension';

    constructor(private plugin: StatusIndicatorExtensionPlugin) {
        this.init = this.init.bind(this);
    }

    init(): SvgEditExtensionObject {
        this.bindMouseEvents();
        return this.plugin;
    }

    addEventListeners(foreignObject) {
        this.plugin.addEventListeners(foreignObject);
    }

    private bindMouseEvents() {
        return this.plugin.bindMouseEvents();
    }
}

@Injectable({ providedIn: 'root' })
class StatusIndicatorExtensionPlugin implements SvgEditExtensionObject {
    constructor(
        private canvasService: CanvasService,
        private inputMode: CanvasInputModeService,
        private selectedElementsService: SelectedElementsService
    ) {}

    callback(deps: any) {}

    bindMouseEvents() {
        document.addEventListener('mousedown', this.handleMouseDown.bind(this));
        document.addEventListener('mousemove', this.handleMouseMove.bind(this));
        document.addEventListener('mouseup', this.handleMouseUp.bind(this));
    }

    private handleMouseDown(event: MouseEvent) {}

    private handleMouseMove(event: MouseEvent) {}

    private handleMouseUp(event: MouseEvent) {
        if (this.inputMode.getMode() === CanvasInputMode.STATUS_INDICATOR) {
            const svgRoot = this.canvasService.getSvgRoot();
            if (event.target !== svgRoot) {
                return;
            }
            const canvas = this.canvasService.getCanvas();

            const rootSctm = this.canvasService.getSCTM();
            const pt = this.canvasService.transformPoint(event.clientX, event.clientY, rootSctm);
            const mouseX = pt.x;
            const mouseY = pt.y;

            const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
            foreignObject.id = canvas.getNextId();
            foreignObject.setAttribute('x', mouseX.toString());
            foreignObject.setAttribute('y', mouseY.toString());
            foreignObject.setAttribute('type', CanvasInputMode.STATUS_INDICATOR);

            foreignObject.setAttribute('width', '12px');
            foreignObject.setAttribute('height', '12px');
            foreignObject.setAttribute('pointer-events', 'all');

            const statusIndicator = document.createElement('div');
            statusIndicator.setAttribute('statusIndicator', 'true');
            statusIndicator.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
            statusIndicator.style.height = 'calc(100% - 2px)';
            statusIndicator.style.width = 'calc(100% - 2px)';
            statusIndicator.style.backgroundColor = '#252d39';
            statusIndicator.style.borderRadius = '50%';
            statusIndicator.style.border = '1px solid #252d39';

            foreignObject.appendChild(statusIndicator);

            const layer = svgRoot.querySelector('.layer');
            layer.appendChild(foreignObject);

            this.addEventListeners(foreignObject);
            canvas.addCommandToHistory(new canvas.history.InsertElementCommand(foreignObject));
            this.selectedElementsService.setSelectedElements([foreignObject]);
            this.inputMode.setMode(CanvasInputMode.SELECT);
        }
    }

    addEventListeners(foreignObject) {
        const statusIndicator = foreignObject.querySelectorAll('[statusIndicator="true"]')[0];
        const observer = new MutationObserver(() => {
            statusIndicator.style.height = 'calc(100% - 2px)';
            statusIndicator.style.width = 'calc(100% - 2px)';
            statusIndicator.style.backgroundColor = '#252d39';
            statusIndicator.style.borderRadius = '50%';
            statusIndicator.style.border = '1px solid #252d39';
        });

        observer.observe(foreignObject, {
            attributes: true,
            attributeFilter: ['x', 'y'],
        });
    }
}
